import { ENTRY_POINT } from "../../global-config";
import { getToken, ValidateToken } from "../Auth/Authentification";

export async function getEmplacementsList(filter, page, itemperpage){
    const options = {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + getToken()
        }
      };
    
    page = page +1;
    
    let data = await fetch(ENTRY_POINT+"/warehouse_locations?"+"page="+page+"&itemsPerPage="+itemperpage+"&product.name="+filter, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error(error);
        });
    
    if(ValidateToken(data) || data !== undefined){
        return data;
    }else{
        return "error";
    }
}

export function editEmplacements(id, code, comment, pin, priority, quantity){
    const options = {
        method: 'PUT',
        headers: {
        'Content-Type': 'application/ld+json',
        Authorization: 'Bearer ' + getToken()
        },
        body: '{"code":"'+code+'", "comment":"'+comment+'", "pin":"'+pin+'", "priority":'+priority+', "quantity":'+quantity+'}'
    };
  
    let data = fetch(ENTRY_POINT+id, options)
            .then((response) => response.json())
            .then(data => {
                return data;
            })
            .catch(error => {
                console.error(error);
            });


    
    if(ValidateToken(data)){
        return data;
    }else{
        return "error";
    }
}

export async function getOneEmplacement(id_spot){
    const options = {
        method: 'GET',
        headers: {
          Authorization: 'Bearer ' + getToken()
        }
      };
      
    let data = await fetch(ENTRY_POINT+id_spot, options)
        .then((response) => response.json())
        .then(data => {
            return data;
        })
        .catch(error => {
            console.error(error);
        });
    
    if(ValidateToken(data) || data !== undefined){
        return data;
    }else{
        return "error";
    }
}